/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
import { FormGroup, FormLabel } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { Controller } from "react-hook-form";
import { InputFieldProps } from "../../types/InputProps";
import { Checkbox } from "../Checkbox";
import { Grid } from "../Grid";
import InputWrapper from "./InputWrapper";

const FormCheckBox = (props: InputFieldProps) => {
  const { name, control, info, hint, label, options = [] } = props;

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        validate: (val: any) =>
          Array.isArray(val) && val.length > 0 || "Select at least one option",
      }}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const selectedValues = Array.isArray(value) ? value : [];
      
        return (
          <InputWrapper info={info} hint={hint} error={error}>
            <FormControl fullWidth error={!!error}>
              <FormLabel>{label}</FormLabel>
              <FormGroup>
                <Grid container display="flex" flexDirection="row">
                  {options.map((option) => (
                    <Checkbox
                      key={option.value}
                      label={option.desc}
                      checked={selectedValues.includes(option.value)}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        const updated = isChecked
                          ? [...selectedValues, option.value]
                          : selectedValues.filter((v) => v !== option.value);
                        onChange(updated);
                      }}
                      name={String(option.value)}
                    />
                  ))}
                </Grid>
              </FormGroup>
            </FormControl>
          </InputWrapper>
        );
      }}
      
    />
  );
};

export default FormCheckBox;